var map = {
	"./11651611730720_ 1@2x.png": "314c",
	"./applyOverseaen1.png": "b49c",
	"./authorizationUrl.png": "d9cd",
	"./basic _ circle_check_outline@2x.png": "f046",
	"./brandLogo.png": "0d75",
	"./businessLicenseUrl.png": "8b1b",
	"./businessLicenseUrl_shili.png": "1150",
	"./cert/business_license_template.png": "f674",
	"./cert/hk_mo_permit.png": "928f",
	"./cert/passport.png": "54f8",
	"./cert/tw_permit_new.png": "092d0",
	"./cert/tw_permit_old.png": "190a",
	"./certificationPicUrl.png": "fa9b",
	"./coolicon@2x.png": "fd5c",
	"./coolicon_1@2x.png": "471b",
	"./email icon@2x.png": "51a1",
	"./idcardBackUrl.png": "3304",
	"./idcardBackUrl_shili.png": "c99f",
	"./idcardFrontUrl.png": "3b04",
	"./idcardFrontUrl_shili.png": "6032",
	"./idcardHandUrl.png": "271f",
	"./idcardHandUrl_shili.png": "b7d6",
	"./idcardUrl.png": "ee34",
	"./left_icon.png": "73ee",
	"./lijiruzhu.png": "f0dd",
	"./message icon@2x.png": "c26d",
	"./provinceApply.png": "8aef",
	"./quan.png": "6a1d",
	"./quan_wei.png": "0d73",
	"./registerCertificationUrl.png": "ce50",
	"./salesAuthorizationLetterUrl.png": "5335",
	"./shopLogo.png": "f9d1",
	"./trademarkOwnerOthers.png": "ded0",
	"./user icon@2x.png": "4c72"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "baf2";